import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=541e8997&lang=pug&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=541e8997&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541e8997')) {
      api.createRecord('541e8997', component.options)
    } else {
      api.reload('541e8997', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=541e8997&lang=pug&", function () {
      api.rerender('541e8997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ColorPicker.vue"
export default component.exports